import { ClarityType } from '../clarityValue.esm.js';

var stringAsciiCV = function stringAsciiCV(data) {
  return {
    type: ClarityType.StringASCII,
    data: data
  };
};

var stringUtf8CV = function stringUtf8CV(data) {
  return {
    type: ClarityType.StringUTF8,
    data: data
  };
};

export { stringAsciiCV, stringUtf8CV };
//# sourceMappingURL=stringCV.esm.js.map
